import React from 'react';

import ItemTestPresentation from './ItemTestPresentation';

export default class ItemTest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showContent: false,
        };
    }

    handleShowContent({ newValue }) {
        const { test, handleActiveId } = this.props;
        this.setState({ showContent: newValue });

        if (handleActiveId && newValue) {
            handleActiveId(test.id);
        }
    }

    render() {
        const {
            test,
            gotoManageQuestion,
            showModalRemoveTest,
            handlePortalRemove,
            handleConfirmRemove,
            activeId,
            gotoDuplicateQuestion,
        } = this.props;
        const { showContent } = this.state;
        return (
            <ItemTestPresentation
                test={test}
                showContent={showContent && activeId === test.id}
                handleShowContent={this.handleShowContent.bind(this)}
                gotoManageQuestion={gotoManageQuestion}
                showModalRemoveTest={showModalRemoveTest}
                handlePortalRemove={handlePortalRemove}
                handleConfirmRemove={handleConfirmRemove}
                gotoDuplicateQuestion={gotoDuplicateQuestion}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tests/components/ItemTest/index.js